import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils";

// Deck badges. `tag*` variants are the uppercase 11px tint tags from the deck;
// solid/soft variants cover status pills. Use with a color variant.
const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-full border font-semibold transition-colors focus:outline-none",
  {
    variants: {
      variant: {
        // soft tint pills (default status look)
        brand: "border-transparent bg-primary-tint text-primary",
        success: "border-transparent bg-success-tint text-success",
        warning: "border-transparent bg-warning-tint text-warning",
        coral: "border-transparent bg-coral-tint text-coral",
        danger: "border-transparent bg-danger-tint text-danger",
        neutral: "border-transparent bg-secondary text-muted-foreground",
        // solid
        solid: "border-transparent bg-primary text-primary-foreground",
        // outline
        outline: "border-border bg-transparent text-foreground",
        // uppercase micro-tag (deck .tag)
        tag: "rounded-[6px] border-transparent bg-primary-tint px-2 py-0.5 text-[11px] uppercase leading-none tracking-[0.06em] font-bold text-primary",
      },
      size: {
        default: "px-2.5 py-0.5 text-xs",
        sm: "px-2 py-0.5 text-[11px]",
        lg: "px-3 py-1 text-sm",
      },
    },
    defaultVariants: { variant: "brand", size: "default" },
  }
);

function Badge({ className, variant, size, ...props }) {
  return <span data-kit="" className={cn(badgeVariants({ variant, size }), className)} {...props} />;
}

export { Badge, badgeVariants };
